import { render, staticRenderFns } from "./Clouds.vue?vue&type=template&id=b849b952&scoped=true&"
var script = {}
import style0 from "./Clouds.vue?vue&type=style&index=0&id=b849b952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849b952",
  null
  
)

export default component.exports